<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            患者列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd"  @click.native="toggleModalAdd">添加</el-button>
                    <el-button type="success" :disabled="disabledEdit" @click="toggleModalEdit">编辑</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-input  placeholder="请输入身份证号" v-model="idCard" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select
                            v-model="status"
                            style="margin:0 10px;width:200px"
                            placeholder="请选择入住状态"> 
                            <el-option
                                v-for="(item,i) in statusValue"
                                :key="i"
                                :label="item"
                                :value="i">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click="rowClick" :height="th" border style="width: 100%;">

                        <el-table-column prop="name" label="姓名"></el-table-column>

                        <el-table-column prop="phone" label="手机号"></el-table-column>

                        <el-table-column prop="idCard" label="身份证号"></el-table-column>

                        <el-table-column prop="address" label="详细住址"></el-table-column>

                        <el-table-column prop="balance"  label="余额(元)"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                row:null,
                menuButtonList:null,
                disabledAdd:true,
                disabledEdit:true,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                idCard:'',
                status:0,
                statusValue:['患者状态','正常','禁用'],
            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.getMenu();
            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
             getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            rowClick(row){
                this.row=row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
                
            },
            init:function(){
                
            },
            handleChange(value) {
                this.roomCode=value[1];
                console.log(this.roomCode);
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.$refs.myEdit.init(this.row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Patient/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        idCard:this.idCard,
                        status:this.status-1,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit = true;
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

        }
    }
</script>

<style lang="scss" scoped>

/deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }

</style>
